import React, { useCallback, useMemo } from 'react';
import { Button } from '@osui/ui';
import { useElementSize } from 'huse';
import { IconLeft } from '@baidu/lsqm-icon';
import Form, { useFormInstance } from '@baidu/icloud-ui-form';
import { Item } from './Item';
import { calFlattenedDefaultValue } from './utils';
import './AdvancedFilters.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function AdvancedFilter({
  value = [],
  advancedSearchIsExpand,
  toggleAdSearchIsExpand
}) {
  const [ref, size] = useElementSize();
  const labelWidth = useMemo(() => {
    const maxNumOfWords = Math.max(...value.map(i => {
      var _i$label;

      return ((_i$label = i.label) === null || _i$label === void 0 ? void 0 : _i$label.length) || 0;
    }));
    return maxNumOfWords > 5 ? 80 : maxNumOfWords * 12;
  }, [value]);
  const width = useMemo(() => value.find(n => n.renderType === 'dateRangePicker') ? 216 : 200, [value]); // 算出一排最多能显示多少个元素

  const oneRowLength = useMemo(() => {
    if (size) {
      return Math.floor(((size === null || size === void 0 ? void 0 : size.width) - 100) / (labelWidth + width + 20));
    }

    return 0;
  }, [size, labelWidth, width]);
  const form = useFormInstance();
  const clear = useCallback(() => {
    const initValue = calFlattenedDefaultValue(value);
    form.setFieldState(`*(${value.map(i => i.name).join(',')})`, s => {
      var _fieldProps, _props;

      const filterItem = value.find(n => n.name === s.name); // 如果字段设置默认值的清空到默认值 没有默认值的判断是否在默认选中第一个中。如果还没有就直接undefined

      s.value = initValue[s.name] || ((_fieldProps = filterItem.fieldProps) !== null && _fieldProps !== void 0 && _fieldProps.selectFirst ? (_props = filterItem.props) === null || _props === void 0 ? void 0 : _props.options[0].value : undefined);
    });
  }, [form, value]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "icloud-ui-pro-table-advanced-filters",
      children: [/*#__PURE__*/_jsx("div", {
        className: "icloud-ui-pro-table-advanced-filters-content",
        style: {
          width: 'calc(100% - 100px)'
        },
        ref: ref,
        children: value.slice(0, advancedSearchIsExpand ? value.length : oneRowLength).map((i, index) => {
          return /*#__PURE__*/_jsxs("div", {
            className: "icloud-ui-pro-table-advanced-filters-content-item",
            children: [/*#__PURE__*/_jsx("div", {
              className: "icloud-ui-pro-table-advanced-filters-content-item-label",
              style: {
                width: labelWidth
              },
              children: i.label
            }), /*#__PURE__*/_jsx(Item, { ...i,
              fieldProps: {
                hideUi: true,
                ...(i.fieldProps || {})
              },
              props: {
                style: {
                  width
                },
                ...(i.props || {})
              }
            })]
          }, i.name ? JSON.stringify(i.name) : index.toString());
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "icloud-ui-pro-table-advanced-filters-control",
        children: /*#__PURE__*/_jsxs("div", {
          onClick: toggleAdSearchIsExpand,
          children: ["\u9AD8\u7EA7\u641C\u7D22 ", /*#__PURE__*/_jsx(IconLeft, {
            style: {
              transform: `rotate(${advancedSearchIsExpand ? 90 : 270}deg)`
            }
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        marginLeft: labelWidth + 20,
        display: advancedSearchIsExpand ? 'flex' : 'none',
        marginBottom: 20
      },
      children: [/*#__PURE__*/_jsx(Form.Submit, {
        size: "middle",
        children: "\u67E5\u8BE2"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: clear,
        style: {
          marginLeft: 12
        },
        children: "\u6E05\u7A7A"
      })]
    })]
  });
}

AdvancedFilter.displayName = "AdvancedFilter";
export default AdvancedFilter;
//# sourceMappingURL=es/AdvancedFilters.js.map